import {
  ActuatorModalityType,
  Slot,
  SlotStatus,
  ThermoActuatorType,
  DeviceDTO,
  ThermoRoomObjectDTO,
  SystemControlType,
} from '@/../client-generator/generated-clients/plants';
import {
  SlotRuleServiceType,
  WorkflowCallbackFunction,
} from './slots-assign-rules-interfaces';
import BaseSlotRuleService from './slots-assign-rules-service';

export default class AssignThermoSharedPumpSlotRuleService extends BaseSlotRuleService {
  declare roomObject: ThermoRoomObjectDTO;

  constructor(
    roomObject: ThermoRoomObjectDTO,
    workflowCallback: WorkflowCallbackFunction
  ) {
    super(
      roomObject,
      -1,
      ThermoActuatorType.SharedPump,
      roomObject.actuatorModalityType ?? ActuatorModalityType.None,
      workflowCallback
    );
    this.slotRuleServiceType = SlotRuleServiceType.THERMO_SHARED_PUMPS;

    this._noOfAdjacent = this.getNoOfAdjacentSlots(
      roomObject.sharedSystemControlType ?? SystemControlType.None
    );
  }

  addOrUpdateSlot(
    slotViewModel: Slot,
    thermoActuatorType = ThermoActuatorType.None
  ) {
    super.addOrUpdateSlot(slotViewModel, ThermoActuatorType.SharedPump);
  }

  onSlotMessage(device: DeviceDTO, slot: Slot) {
    if (this.roomObject != null) {
      const tmpActuatorType = this.getCurrentThermoActuatorType(
        slot.thermoActuatorTypes,
        this.roomObject.id
      );
      if (
        !this.isSlotLinkedWithCurrentRoomObject(slot) &&
        this.isSlotLinkedAsPump(slot) &&
        (slot.status == SlotStatus.NotConfigured ||
          slot.status == SlotStatus.Configured)
      ) {
        this.markOrUnmarkSlot(
          this.roomObject,
          slot,
          device,
          SlotStatus.Configured,
          SlotStatus.MarkedForLinking
        );
      } else if (
        slot.status == SlotStatus.NotConfigured ||
        tmpActuatorType == ThermoActuatorType.SharedPump
      ) {
        super.onSlotMessage(device, slot);
      }
    }
  }

  isSlotCompatibleForMarking(slot: Slot) {
    const tmpActuatorType = this.getCurrentThermoActuatorType(
      slot.thermoActuatorTypes,
      this.roomObject.id
    );
    return (
      slot != null &&
      (tmpActuatorType == ThermoActuatorType.SharedPump ||
        this.isSlotRoomObjectTypeMatchingAndNotLinked(slot) ||
        this.isSlotLinkedAsPump(slot))
    );
  }

  isLimitationReached(slotsToBeMarked: Slot[] | null) {
    if (this.roomObject?.devices != null && slotsToBeMarked != null) {
      var noOfSelectedValves = this.roomObject.devices
        .flatMap((d) => d.slots)
        .filter((s) =>
          [ThermoActuatorType.SharedPump].includes(
            this.getCurrentThermoActuatorType(
              s?.thermoActuatorTypes,
              this.roomObject.id
            )
          )
        ).length;

      var noOfSlotsToBeAddedInParam = slotsToBeMarked.length;

      if (
        noOfSelectedValves + noOfSlotsToBeAddedInParam <=
        this.MaximumNoOfThermostatSlots
      ) {
        return false;
      }
      return true;
    }

    return false;
  }
}
